module.exports = "<div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/session-notification/session-notification.html
// module id = 624
// module chunks = 0